<template>
  <Container>
    <template #header>
      <Text :weight="600" :height="130" align="left">
        {{ title }}
      </Text>
    </template>
    <template #body>
      <div class="table_body">
        <table>
          <thead class="hidden md:table-header-group">
            <tr>
              <th
                v-for="{ key, width, label, classes } in columns"
                :key="key"
                :style="{ width, maxWidth: width }"
                :class="classes"
                class="text-[12px]"
              >
                <Text
                  :weight="600"
                  :height="130"
                  align="left"
                  pattern="body3"
                  color="#7E7E7E"
                >
                  {{ label }}
                </Text>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in visibleData" :key="index">
              <td
                v-for="{ key, width, component, classes } in columns"
                :key="key"
                :style="{ width }"
                :class="classes"
              >
                <div class="flex flex-col">
                  <p class="md:hidden">{{ row[key] }}</p>
                  <component
                    v-if="component"
                    :is="component"
                    :value="row[key]"
                  />
                  <span class="text-base" :class="classes" v-else>
                    {{ row[key] }}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <td colspan="100%">
              <div class="table_footer">
                <button
                  @click="showMore"
                  class="table_footer_button"
                  :disabled="visibleRows >= data.length"
                >
                  {{ $t("Show more") }}
                  asdf
                  <BaseSvgIcon name="arrow-right-simple" class="arrow" />
                </button>
                <div class="pagination">
                  <Text
                    pattern="body2"
                    :weight="500"
                    :height="150"
                    align="left"
                  >
                    {{ currentPage }}
                    <span>of</span>
                    {{ totalPages }}
                  </Text>

                  <div class="arrows">
                    <button @click="prevPage" :disabled="currentPage === 1">
                      <BaseSvgIcon
                        name="arrow-right-simple"
                        class="icon left"
                      />
                    </button>
                    <button
                      @click="nextPage"
                      :disabled="currentPage === totalPages"
                    >
                      <BaseSvgIcon name="arrow-right-simple" class="icon" />
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </tfoot>
        </table>
      </div>
    </template>
  </Container>
</template>

<script>
import { Container, Text, BaseSvgIcon } from "@/shared/ui";
import { comma } from "@/shared/utils/format";
import "@/assets/icons/SVG/copy.svg";
import "@/assets/icons/SVG/check2.svg";
import "@/assets/icons/SVG/arrow-right-simple.svg";

export default {
  name: "BaseTable",
  components: { Text, Container, BaseSvgIcon },
  props: {
    title: {
      type: String,
      default: "",
    },
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      currentPage: 1,
      visibleRows: this.pageSize,
    };
  },
  computed: {
    visibleData() {
      const start = (this.currentPage - 1) * this.visibleRows;
      const end = start + this.visibleRows;
      return this.data.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.data.length / this.visibleRows);
    },
  },
  methods: {
    comma,
    copyToClipboard(value) {
      navigator.clipboard.writeText(value);
    },
    showMore() {
      this.visibleRows += 10;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  &_body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;

    table {
      width: 100%;
      border-collapse: collapse;

      thead {
        tr {
          th {
            padding-top: 20px;
            padding-bottom: 12px;
            text-align: left;
            border-bottom: 1px solid var(--Dark-850, #1a1a1a);
          }
        }
      }

      tbody {
        tr {
          td {
            padding: 12px 0px;
            border-bottom: 1px solid var(--Dark-850, #1a1a1a);
          }
        }
      }
    }
  }

  &_footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 22px;

    button {
      user-select: none;
    }

    span {
      color: var(--Dark-50, #787878);
    }

    &_button {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      gap: 9px;

      .arrow {
        width: 16px;
        height: 16px;
        transform: rotate(90deg);
      }
    }

    .pagination {
      display: flex;
      align-items: center;
      gap: 16px;

      .icon {
        width: 24px;
        height: 24px;
      }

      .left {
        transform: rotate(180deg);
      }

      .arrows {
        display: flex;
        gap: 0px;
      }
    }
  }
}
</style>
